import React, { useCallback, useState } from 'react';
import { shiftOfferLikeCount } from '../../../../layout/common/js/utils/offerLikeCount';
import type AccountClient from '../../../model/api/account/Client';
import './OfferLike.scss';

interface IProps {
	offerId: number;
	initialLiked: boolean;
	isLoggedIn: boolean;
	signUpUrl: string;
	client: AccountClient;
}

export const OfferLike = ({ offerId, initialLiked, isLoggedIn, signUpUrl, client }: IProps): React.ReactNode => {
	const [isLiked, setIsLiked] = useState(initialLiked);
	const [isPending, setIsPending] = useState(false);

	const onClick = useCallback(
		(event: React.MouseEvent<HTMLButtonElement>) => {
			event.preventDefault();
			event.stopPropagation();

			if (!isLoggedIn) {
				window.open(signUpUrl, '_blank', 'noopener');
				return;
			}

			if (isPending) {
				return;
			}

			const nextLiked = !isLiked;
			setIsLiked(nextLiked);
			setIsPending(true);

			client
				.saveOfferLike(offerId, nextLiked)
				.then((isChanged) => {
					if (isChanged) {
						shiftOfferLikeCount(nextLiked ? 1 : -1);
					}
				})
				.catch((error) => {
					console.error('Offer like failed', error);
					setIsLiked(!nextLiked);
				})
				.finally(() => setIsPending(false));
		},
		[client, isLiked, isLoggedIn, isPending, offerId, signUpUrl]
	);

	const label = isLiked ? 'Odebrat z uložených nabídek' : 'Uložit nabídku';

	return (
		<button
			type="button"
			className={`offer-like__button${isLiked ? ' offer-like__button--active' : ''}`}
			title={label}
			aria-label={label}
			aria-pressed={isLiked}
			data-cy="offer-like"
			onClick={onClick}
		/>
	);
};
